declare var $: any;

$(window).on('load', () => {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'fcJoinEntry') {
        fcJoinEntry();
    } else if (bodyId === 'CustomerEditFin') {
        customerEditFin();
    } else if (bodyId === 'MyPage') {
        myPage();
    } else if (bodyId === 'fc_help') {
        fcHelp();
    } else if (bodyId === 'fc_contactFin') {
        fcContactFin();
    }

    setPrivacyLink();
    setFavicon();
    initAccordion();
});

function setPrivacyLink() {
    const url = 'https://www.ponycanyon.co.jp/privacy_policy';
    $('#cmnfoot_button_privacy').attr({
        'href': url,
        'target': '_blank'
    });
}

function fcJoinEntry() {
    // 自動継続更新のチェックボクスをonにする
    $('#card_fc_auto').prop('checked', true);

    $('.link_fc').text('利用規約');
    $('.link_ec').attr('href', 'https://www.ponycanyon.co.jp/privacy_policy');
}

function customerEditFin() {
    const text = '受取り前の注文がある場合、配送先の変更は「ご注文履歴」から手続きを行ってください。';
    const $alert = $('.alert');
    if ($alert.text().indexOf(text) > 0) {
        $alert.text($alert.text().replace(text, ''));
    }
}

function myPage() {
    $('.t_title').text('My Page');
    $('#panel_cust_bar').remove();
}

function fcHelp() {
    $('.t_title').text('よくある質問');
}

function fcContactFin() {
    $('.t_title').text('お問い合わせメール送信完了');
}

function setFavicon() {
    var link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link') as HTMLLinkElement;
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'https://hanazawakana-fc.com/favicon.png'; //-> ここに画像のパスを設定する
    document.getElementsByTagName('head')[0].appendChild(link);
}

function initAccordion() {
    $('.accordion').each(function () {
        const $title = $(this).find('.accordion__title');
        const $icon = $title.find('.accordion__title-icon');
        const $body = $title.next('.accordion__body');
        $title.on('click', function() {
            $icon.toggleClass('open');
            $body.slideToggle();
        });
    });
}